import React from 'react';
import SimpleForm from '../teal-react/components/organisms/SimpleForm';
import { useMaterialsLookup, useUnitLookup } from '../graphql/queries';
import { useSave } from '../graphql/hooks';
import Loading from '../teal-react/components/molecules/Loading';

interface FormulaMaterialFormProps {
  model: any;
  onClose?: () => void;
}

const FormulaMaterialForm = ({ model, onClose }: FormulaMaterialFormProps) => {
  const { data: units } = useUnitLookup();
  const { data: materials } = useMaterialsLookup();
  const save = useSave('formula_material', 'formula_material');

  if (!units || !materials) {
    return <Loading />;
  }
  return (
    <SimpleForm
      header="Edit Material"
      cancel={onClose}
      model={model}
      save={({ modified, merged }: { modified: any; merged: any }) => {
        if (Boolean(model.id)) {
          save({
            id: model.id,
            ...modified,
          });
        } else {
          save(merged, true);
        }

        onClose?.();
      }}
      fields={[
        {
          label: 'Material',
          name: 'material_id',
          size: 12,
          options: materials.material.map((u: any) => ({
            label: u.name,
            value: u.id,
            id: u.id,
          })),
          // disabled: Boolean(model.id),
          validate: { required: true },
          filterable: !Boolean(model.id), // use searchable select
        },
        {
          name: 'amount',
          label: 'Amount',
          size: 3,
          validate: { required: true },
          number: true,
        },
        {
          name: 'unit_id',
          label: 'Unit',
          size: 3,
          options: units.unit.map((u: any) => ({
            label: u.name,
            value: u.id,
          })),
          validate: { required: true },
        },
        {
          name: 'remark',
          label: 'Remark',
          size: 6,
        },
        {
          name: 'weight_percentage',
          label: 'Weight %',
          size: 6,
          number: true,
          validate: { required: true },
        },
      ]}
    />
  );
};

export default FormulaMaterialForm;
